import { render, staticRenderFns } from "./RightshipInspectorList.vue?vue&type=template&id=16e63084&scoped=true&"
import script from "./RightshipInspectorList.vue?vue&type=script&lang=js&"
export * from "./RightshipInspectorList.vue?vue&type=script&lang=js&"
import style0 from "./RightshipInspectorList.vue?vue&type=style&index=0&id=16e63084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e63084",
  null
  
)

export default component.exports